
/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import * as React from "react";
import { InputProps } from "../../types/InputProps";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { InputAdornment } from "@material-ui/core";

class InputSelect extends React.Component<InputProps> {

    element: any;

    componentDidMount() {    
        // Hack : required not work in native
        if ( this.props.required ) {
            const input = this.element.querySelector("input[type='text']");
            input.setAttribute("required", true);
        }
    }

    render() {
        return (
            <span ref={(ref) => this.element = ref}>
                <TextField                                
                    select={true}
                    label={this.props.label ? this.props.label : null}
                    placeholder={this.props.placeholder ? this.props.placeholder : null}
                    value={this.props.value ? this.props.value + "" : ""}
                    error={this.props.error ? this.props.error : false}
                    style={{width: "100%"}}
                    helperText={this.props.legend ? this.props.legend : ""}
                    required={this.props.required}
                    onChange={(event) => this.props.onChange(event.target.value, event.target)}
                    disabled={this.props.disabled}  
                    inputProps={{                
                        type: "text",
                        style: {
                            top: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            position: "absolute",
                            pointerEvents: "none"
                        },
                        customvalidation: this.props.customValidation
                    }}
                    InputProps={{
                        endAdornment: this.props.description ? <InputAdornment position="end">{this.props.description}</InputAdornment> : null                
                    }}
                >
                    {this.props.items.map(option => (
                        <MenuItem key={option.name} value={option.name} style={{fontWeight: 300}} >
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </span>
        );
    }
}

export default InputSelect;


// WEBPACK FOOTER //
// ./src/components/InputSelect/InputSelect.component.tsx